export const formatNumberToUSD = (number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(number);
};

export const formatSubtotal = (value, perUnitMidPrice, hasPriceRange) => {
  let subtotal = Number(value) * perUnitMidPrice;
  if (hasPriceRange == "true") {
    return formatNumberToUSD(subtotal) + "*";
  }
  return formatNumberToUSD(subtotal);
};
